import { Params } from 'ahooks/lib/useAntdTable/types';
import { RawAxiosRequestHeaders } from 'axios';
import dayjs from 'dayjs';
import { lowerCase, startCase } from 'lodash';

import { apiGet } from 'api';

import { Status } from 'components';

import { addQueryParamsToURL, getDateForPayload, getTableQueryParams } from 'utils';

import { Links } from 'links';

import { AdminContributedOffer, AdminContributedOffersResponse, OfferLineItemMatch } from 'codegen';
import { TColumn, TFieldProps } from 'types';

export const columns: TColumn<OfferLineItemMatch>[] = [{
  title: 'Collector ID',
  dataIndex: 'collectorId',
}, {
  title: 'Points',
  dataIndex: 'milesAmount',
}, {
  type: TColumn.type.Status,
  title: 'Status',
  dataIndex: 'status',
}, {
  type: TColumn.type.IDRedirect,
  title: 'Snap ID',
  dataIndex: 'snapId',
  pathname: Links.Snaps,
}, {
  type: TColumn.type.Date,
  title: 'Created At',
  dataIndex: 'createdAt',
}];

export const fields = (isAdmin: boolean): TFieldProps[] => [{
  type: TFieldProps.type.DateRangePicker,
  name: 'submittedDates',
  colProps: { xs: 8, xxl: 4 },
  placeholder: 'Match Created Date',
}, {
  type: TFieldProps.type.Select,
  name: 'statuses',
  mode: 'multiple',
  options: Object.values(AdminContributedOffer.status).map((st) => ({ label: startCase(lowerCase(st)), value: st })),
  colProps: { xs: 8, xxl: 3 },
  placeholder: 'Status',
  tagRender: ({ value }) => <Status key={value} status={value} />,
  maxTagCount: 'responsive',
}, ...(isAdmin
  ? [{
    type: TFieldProps.type.Text,
    name: 'collectorNumber',
    colProps: { xs: 4, xxl: 3 },
    placeholder: 'Collector Number',
  }]
  : []
), {
  type: TFieldProps.type.Text,
  name: 'collectorId',
  colProps: { xs: !isAdmin ? 8 : 4, xxl: 3 },
  placeholder: 'Collector ID',
}];

interface IInitialValues {
  statuses: string[];
  collectorId?: string;
  submittedDates: dayjs.Dayjs[] | null;
  collectorNumber: string;
}

export const handleContributedOfferTableChange = (
  headers: RawAxiosRequestHeaders,
  offerId?: string,
) => async (
  params: Params[0],
  {
    statuses,
    collectorId,
    submittedDates,
    collectorNumber,
  }: IInitialValues,
) => {
  const { sort, ...otherParams } = getTableQueryParams(params);

  const queryParams = {
    ...otherParams,
    ...(statuses && { statuses }),
    ...(collectorId && { collectorId }),
    ...(collectorNumber && { collectorNumber }),
    ...(submittedDates && {
      createdTo: getDateForPayload(dayjs(submittedDates[1]).endOf('day')),
      createdFrom: getDateForPayload(dayjs(submittedDates[0]).startOf('day')),
    }),
  };

  const url = addQueryParamsToURL(`offers/details/${offerId}/contributions`, queryParams);

  const { data } = await apiGet<AdminContributedOffersResponse>({ url, headers });

  return {
    list: data.offers,
    total: data.total,
  };
};
